const convertCamelToSentence = (text) => {
    if (text) {
      const result = text.replace(/([A-Z])/g, " $1");
      return result.charAt(0).toUpperCase() + result.slice(1);
    }
    return ''
  }

  export default convertCamelToSentence
